// extracted by mini-css-extract-plugin
export default {"rating":"qy-z","numberOfStars":"ry-z","count":"sy-z","barGraphSpacing":"ty-z","barGraph":"uy-z"};